import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'postalAddress',
  standalone: true
})
export default class PostalAddressPipe implements PipeTransform {
  public transform(addressObject: {
    postal_street: string,
    postal_housenumber: string,
    postal_housenumberext: string,
    postal_zipcode: string,
    postal_city: string
  } | null): string {

    if (!addressObject) {
      return "";
    }

    const separator: string = ', ';
    const line1: string = ((addressObject.postal_street ?? '') + ' ' + (addressObject.postal_housenumber ?? '') + (addressObject.postal_housenumberext ?? '')).toString().trim();
    const line2: string = ((addressObject.postal_zipcode ?? '') + ' ' + (addressObject.postal_city ?? '')).toString().trim();

    return line1 + (line1.trim().length > 0 ? separator : '') + line2;
  }
}
